import ExecuteStockTake from "../../../../components/@documents/stock_takes/ExecuteStockTake";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function StockTakeExecutePage() {

    return (
        <ExecuteStockTake 
            routeType={routeTypes.workstation}
        />
    )
}